import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Grid } from "@mui/material";
import { Email } from "@mui/icons-material";

function Socials() {
  return (
    <Grid
      container
      spacing={3}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="https://www.linkedin.com/in/devika-u-h-07482520a/"
        >
          {/* <LinkedInIcon fontSize="large" /> */}
        </a>
      </Grid>
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="https://github.com/Devika0713"
        >
          {/* <GitHubIcon fontSize="large" /> */}
          <img src="assets/Icon (6).png" alt="GitHub Icon" />
        </a>
      </Grid>
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="https://twitter.com/Devika_30"
        >
          <img src="assets/twitter.png" alt="twitterIcon" />
          {/* <TwitterIcon fontSize="large" /> */}
        </a>
      </Grid>
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="https://www.instagram.com/__devika_u_h"
        >
          <img src="assets/instagram.png" alt="Instagram Icon" />
          {/* <InstagramIcon fontSize="large" /> */}
        </a>
      </Grid>
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="mailto: devikauh620@gmail.com"
        >
          <img src="assets/Icon (1).png" alt="Mail Icon" />
          {/* <Email fontSize="large" /> */}
        </a>
      </Grid>
      <Grid item>
        {" "}
        <a
          // style={{ color: "black" }}
          href="mailto: devikauh620@gmail.com"
        >
          <img src="assets/Icon (2).png" alt="Linkedin Icon" />
          {/* <Email fontSize="large" /> */}
        </a>
      </Grid>
    </Grid>
  );
}

export default Socials;
